import { createSelector } from 'reselect'

const productModuleSelector = (state) =>
  (state.productModules && state.productModules.productModules) || null

export const selectProductModules = createSelector(
  [productModuleSelector],
  (productModules) => {
    return { productModules }
  },
)

export const selectProductModulesPresent = createSelector(
  [productModuleSelector],
  (productModules) => {
    return {
      productModulesPresent: productModules && productModules.length > 0,
    }
  },
)
